import React from 'react'

// import logo from '../assests/logo.png';
import homepage from '../assests/homepage1.svg';
import { useNavigate } from 'react-router-dom';
const Homepage = () => {

    const navigate = useNavigate();
    // const [showDropdown, setShowDropdown] = useState(false);

  return (
    <div className="homepage">
      {/* <img src={logo} alt="logo" className="logo" /> */}
      <img src={homepage} style={{width: '100%'}} alt="homepage" className="homepage-image" />
      {/* <h1 className="logo-text">Wedding Poll Game</h1> */}

{/* Icons in the bottom right corner */}
      <div className="icons">
        <i className="fa fa-home"></i>
        <i className="fa fa-video" onClick={() => navigate('/Video')}></i>
        <i className="fa fa-info" onClick={() => navigate('/Questionone')}></i>

      </div>
    </div>
  )
}

export default Homepage